/**
 * Route definitions for the dashboard users section (user list,
 * user detail, create/edit).
 * Mirrors the pattern in views/admin/billing/routes.tsx.
 */
import { RouteObject } from "react-router-dom";
import { withHandle } from "../../../utils/route.util";
import { DashboardUserCreateView } from "./DashboardUserCreateView";
import { DashboardUserEditView } from "./DashboardUserEditView";
import { DashboardUsersView } from "./DashboardUsersView";
import { DashboardUserView } from "./DashboardUserView";

export const dashboardUsersRoutes: RouteObject[] = [
  {
    path: "dashboard-users",
    element: <DashboardUsersView />,
    ...withHandle("admin-dashboard-users"),
    children: [
      {
        path: "create",
        element: <DashboardUserCreateView />,
        ...withHandle("admin-dashboard-user-create"),
      },
      {
        path: ":id",
        element: <DashboardUserView />,
        ...withHandle("admin-dashboard-user-detail"),
      },
      {
        path: ":id/edit",
        element: <DashboardUserEditView />,
        ...withHandle("admin-dashboard-user-edit"),
      },
    ],
  },
];
